import { render, staticRenderFns } from "./EmployersByStatusTable.vue?vue&type=template&id=3172a63c&"
import script from "./EmployersByStatusTable.vue?vue&type=script&lang=js&"
export * from "./EmployersByStatusTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports